import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Result, ResultData } from '../_models/index';
import { environment } from '../../environments/environment';

var URL = environment.url_django;

@Injectable()
export class ResultService {
    constructor(private http: HttpClient) { }

    getAll(component_id: Number) {
        let user: any ;
        if (localStorage.getItem('currentUserId')) {
            user = JSON.parse(localStorage.getItem('currentUserId'));
        }
        let params = new HttpParams();
        params = params.append('component', String(component_id));
        if(user.role == 1){ // National team member
          params = params.append('team', user.team);
          params = params.append('save_by', 'team');
        }
        else{
          params = params.append('user', user.id);
          params = params.append('save_by', 'user');
        }
        return this.http.get<Result[]>(URL+'pss_app/result/', {params: params});
    }
    getResultData(component_id: Number) {
        let user: any ;
        if (localStorage.getItem('currentUserId')) {
            user = JSON.parse(localStorage.getItem('currentUserId'));
        }
        let params = new HttpParams();
        params = params.append('component', String(component_id));
        if(user.role == 1){ // National team member
          params = params.append('team', user.team);
          params = params.append('save_by', 'team');
        }
        else{
          params = params.append('user', user.id);
          params = params.append('save_by', 'user');
        }
        console.log('getResultData: params')
        console.log(params);
        return this.http.get<ResultData[]>(URL+'pss_app/result1/', {params: params});
    }
    getSummaryResults(component_id: Number) {
        let user: any ;
        if (localStorage.getItem('currentUserId')) {
            user = JSON.parse(localStorage.getItem('currentUserId'));
        }
        let params = new HttpParams();
        params = params.append('component', String(component_id));
        if(user.role == 1){ // National team member
          params = params.append('team', user.team);
          params = params.append('save_by', 'team');
        }
        else{               //Generic User
          params = params.append('user', user.id);
          params = params.append('save_by', 'user');
        }
        return this.http.get<ResultData[]>(URL+'pss_app/team-summary-results/', {params: params});
    }
    create(objResult: any, component: number, is_partial: boolean=false) {
        let user: any ;
        if (localStorage.getItem('currentUserId')) {
            user = JSON.parse(localStorage.getItem('currentUserId'));
        }
        var data = {component: component, data: objResult, is_partial:is_partial, team:null,user:null,save_by:null};
        if(user.role == 1){ // National team member
          data.team = user.team;
          data.save_by = 'team'
          }
        else{               // Generic User
          data.user = user.id;
          data.save_by = 'user'
          }
        console.log('data');
        console.log(data);
        return this.http.post(URL+'pss_app/result/', data);

    }
}



// WEBPACK FOOTER //
// ./src/app/_services/result.service.ts